import { PERMISSION_SCOPES } from "components/layout/AccessControl";

import { PATHS } from "./routeConfig";

export const MenuTypes = {
  GROUP: "group",
  ITEM: "item",
  COLLAPSE: "collapse",
  COLLAPSE_LIST: "collapse-list",
};

export const MenuList = [
  {
    title: "Main",
    type: MenuTypes.GROUP,
    items: [
      // {
      //   title: "Dashboard",
      //   type: MenuTypes.ITEM,
      //   badge: 4,
      //   badgeBg: "primary",
      //   badgeClassName: "badge-numeric",
      //   href: PATHS.DASHBOARD,
      //   icon: "inic inic-home",
      //   module: "Dashboard",
      //   permission: "View",
      // },
      {
        title: "Users",
        type: MenuTypes.COLLAPSE,
        module: ["Admin Users", "Individual Users"],
        icon: "inic inic-person",
        permission: "View",

        eventKey: PATHS.USER,
        items: [
          {
            title: "Individual Users",
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.USER_LIST}`,
            module: "Individual Users",
            permission: "View",
          },
          // {
          //   title: "Business Users",
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.USER}/${PATHS.BUSINESS_USER_LIST}`,
          //   module: "Business Users",
          //   permission: "View",
          // },
          {
            title: "Admin Users",
            type: MenuTypes.ITEM,
            href: `${PATHS.USER}/${PATHS.ADMIN_USER}`,
            module: "Admin Users",
            permission: "View",
          },
        ],
      },
      {
        title: "Role",
        type: MenuTypes.ITEM,
        href: PATHS.ROLE,
        badge: "New",
        badgeBg: "secondary",
        badgeClassName: "badge-text",
        icon: "inic inic-circle-tick",
        module: "Role",
        permission: "View",
      },
      {
        title: "Properties",
        type: MenuTypes.COLLAPSE,
        module: [
          "Property",
          "Property Dividend",
          "Property Sales Notification",
          "Property Sales Proceed",
        ],
        icon: "inic inic-home",
        permission: "View",
        eventKey: PATHS.USER,
        items: [
          {
            title: "Properties",
            type: MenuTypes.ITEM,
            href: `${PATHS.PROPERTY}/${PATHS.PROPERTY_LIST}`,
            module: "Property",
            permission: "View",
          },
          {
            title: "Property Dividends",
            type: MenuTypes.ITEM,
            href: `${PATHS.PROPERTY}/${PATHS.PROPERTY_DIVIDENDS}`,
            module: "Property Dividend",
            permission: "View",
          },
          {
            title: "Property Sales Notification",
            type: MenuTypes.ITEM,
            href: `${PATHS.PROPERTY}/${PATHS.PROPERTY_SALES_NOTIFICATION}`,
            module: "Property Sales Notification",
            permission: "View",
          },
          {
            title: "Sale Proceeds",
            type: MenuTypes.ITEM,
            href: `${PATHS.PROPERTY}/${PATHS.SALES_PROCEEDS}`,
            module: "Property Sales Proceed",
            permission: "View",
          },
        ],
      },
      // {
      //   title: "Gemstone",
      //   type: MenuTypes.COLLAPSE,
      //   module: [
      //     "Gemstone",
      //     "Gemstones Sales Notification",
      //     "Gemstones Sales Proceed",
      //   ],
      //   icon: "inic inic-crown",
      //   permission: "View",
      //   eventKey: PATHS.USER,
      //   items: [
      //     {
      //       title: "Gems",
      //       type: MenuTypes.ITEM,
      //       href: `${PATHS.GEMS}/${PATHS.GEMS_LIST}`,
      //       module: "Gemstone",
      //       permission: "View",
      //     },

      //     {
      //       title: "Sales Notification",
      //       type: MenuTypes.ITEM,
      //       href: `${PATHS.GEMS}/${PATHS.GEMS_SALES_NOTIFICATION}`,
      //       module: "Gemstones Sales Notification",
      //       permission: "View",
      //     },
      //     {
      //       title: "Sale Proceeds",
      //       type: MenuTypes.ITEM,
      //       href: `${PATHS.GEMS}/${PATHS.GEMS_SALES_PROCEEDS}`,
      //       module: "Gemstones Sale Proceeds",
      //       permission: "View",
      //     },
      //   ],
      // },
      {
        title: "Investment",
        type: MenuTypes.COLLAPSE,
        module: ["Investment: Property", "Investment: Gemstone"],
        icon: "inic inic-dollar",
        permission: "View",

        eventKey: PATHS.INVESTMENT,
        items: [
          {
            title: "Property",
            type: MenuTypes.ITEM,
            href: `${PATHS.INVESTMENT}/${PATHS.INVESTMENT_PROPERTY}`,
            module: "Investment: Property",
            permission: "View",
          },
          // {
          //   title: "Gems",
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.INVESTMENT}/${PATHS.INVESTMENT_GEMS}`,
          //   module: "Investment: Gems",
          //   permission: "View",
          // },
        ],
      },
      {
        title: "Transactions",
        type: MenuTypes.COLLAPSE,
        module: [
          "Transactions: Deposits",
          "Transactions: Withdrawal",
          "Transactions: Referral Rewards",
        ],
        icon: "inic inic-credit-card",
        permission: "View",
        eventKey: PATHS.TRANSACTIONS,
        items: [
          {
            title: "Deposits",
            type: MenuTypes.ITEM,
            href: `${PATHS.TRANSACTIONS}/${PATHS.DEPOSITS}`,
            module: "Transactions: Deposits",
            permission: "View",
          },
          {
            title: "Withdrawal",
            type: MenuTypes.ITEM,
            href: `${PATHS.TRANSACTIONS}/${PATHS.WITHDRAWALS}`,
            module: "Transactions: Withdrawal",
            permission: "View",
          },
          {
            title: "Referral Rewards",
            type: MenuTypes.ITEM,
            href: `${PATHS.TRANSACTIONS}/${PATHS.REFERRAL_REWARDS}`,
            module: "Transactions: Referral Rewards",
            permission: "View",
          },
        ],
      },
      {
        title: "Exit Window",
        type: MenuTypes.COLLAPSE,
        module: ["Exit Window: Property", "Exit Window: Gems"],
        icon: "inic inic-home",
        permission: "View",
        eventKey: PATHS.EXIT_WINDOW,
        items: [
          {
            title: "Property",
            type: MenuTypes.ITEM,
            href: `${PATHS.EXIT_WINDOW}/${PATHS.EXIT_WINDOW_PROPERTY}`,
            module: "Exit Window: Property",
            permission: "View",
          },
          // {
          //   title: "Gems",
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.EXIT_WINDOW}/${PATHS.EXIT_WINDOW_GEMS}`,
          //   module: "Exit Window: Gems",
          //   permission: "View",
          // },
        ],
      },
    ],
  },
  {
    title: "General",
    type: MenuTypes.GROUP,
    items: [
      {
        title: "Master",
        role: PERMISSION_SCOPES.Master,
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-crown",
        eventKey: PATHS.MASTER_MANAGEMENT,
        module: [
          "Master: Country",
          "Master: Language",
          "Master: Amenities",
          "Master: Subsidiary",
          "Master: Gemstone Type",
          "Master: Industry",
          "Master: Employment Role",
          "Master: Property Type",
        ],
        permission: "View",
        items: [
          {
            title: "Country",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.COUNTRY}`,
            module: "Master: Country",
            permission: "View",
          },
          // {
          //   title: "Language",
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.LANGUAGE}`,
          //   module: "Language",
          //   permission: "View",
          // },
          {
            title: "Amenities",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.AMENITIES}`,
            module: "Master: Amenities",
            permission: "View",
          },
          {
            title: "Subsidiary",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.SUBSIDARIES}`,
            module: "Master: Subsidiary",
            permission: "View",
          },
          // {
          //   title: "Gemstone Type",
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.GEMSTONE_TYPE}`,
          //   module: "Master: Gemstone Type",
          //   permission: "View",
          // },
          {
            title: "Industry",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.INDUSTRIES}`,
            module: "Master: Industry",
            permission: "View",
          },
          {
            title: "Roles",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.ROLES_LIST}`,
            module: "Master: Employment Role",
            permission: "View",
          },
          {
            title: "Property Type",
            type: MenuTypes.ITEM,
            href: `${PATHS.MASTER_MANAGEMENT}/${PATHS.PROPERTY_TYPE}`,
            module: "Master: Property Type",
            permission: "View",
          },
        ],
      },
      {
        title: "Reports",
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-file",
        eventKey: PATHS.REPORTS,
        module: ["Report: User Report", "Report: Transaction Report"],
        permission: "View",
        items: [
          {
            title: "Daily User Report",
            type: MenuTypes.ITEM,
            href: `${PATHS.REPORTS}/${PATHS.DAILY_USER_REPORT}`,
            module: "Report: User Report",
            permission: "View",
          },
          {
            title: "Transaction Report",
            type: MenuTypes.ITEM,
            href: `${PATHS.REPORTS}/${PATHS.TRANSACTION_REPORT}`,
            module: "Report: Transaction Report",
            permission: "View",
          },
        ],
      },
      {
        title: "Email Templates",
        permission: "View",
        module: "Email Template",
        type: MenuTypes.ITEM,
        href: PATHS.EMAIL_TEMPLATES,
        icon: "inic inic-email",
        badge: 4,
        badgeBg: "primary",
        badgeClassName: "badge-numeric",
      },
      {
        title: "Content",
        type: MenuTypes.COLLAPSE,
        eventKey: PATHS.CONTENT,
        module: ["CMS Pages", "FAQs"],
        permission: "View",
        icon: "inic inic-file",
        items: [
          // {
          //   title: "FAQ List",
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.CONTENT}/${PATHS.FAQS}/${PATHS.FAQS_LIST}`,
          //   module: "FAQs",
          //   permission: "View",
          // },
          {
            title: "CMS Pages",
            type: MenuTypes.ITEM,
            href: `${PATHS.CONTENT}/${PATHS.CMS_PAGES}`,
            module: "CMS Pages",
            permission: "View",
          },
        ],
      },
      {
        title: "Inbox",
        type: MenuTypes.ITEM,
        href: PATHS.CONTACT_US,
        icon: "inic inic-support",
        module: "Contact Us",
        permission: "View",
      },
      {
        title: "Settings",
        type: MenuTypes.COLLAPSE,
        icon: "inic inic-settings",
        eventKey: PATHS.SETTINGS,
        module: ["Configurations", "Notification"],
        permission: "View",
        items: [
          {
            title: "Configuration",
            type: MenuTypes.ITEM,
            href: `${PATHS.SETTINGS}/${PATHS.GENERAL_SETTINGS}`,
            module: "Configurations",
            permission: "View",
          },
          {
            title: "Notification",
            type: MenuTypes.ITEM,
            href: `${PATHS.SETTINGS}/${PATHS.NOTIFICATIONS}`,
            module: "Notification",
            permission: "View",
          },
          // {
          //   title: "Social Media",
          //   role: PERMISSION_SCOPES.Settings,
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.SETTINGS}/${PATHS.SOCIAL_MEDIA}`,
          //   // linkClassName: "text-black",
          // },
          // {
          //   title: "Payment Gateway",
          //   role: PERMISSION_SCOPES.Settings,
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.SETTINGS}/${PATHS.PAYMENT_GATEWAY}`,
          //   // linkClassName: "text-black",
          // },
          // {
          //   title: "SMTP / SMS Details",
          //   role: PERMISSION_SCOPES.Settings,
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.SETTINGS}/${PATHS.SMTP_SMS_DETAILS}`,
          //   // linkClassName: "text-black",
          // },
          // {
          //   title: "Email Notifications",
          //   module: "Notification",
          //   permission: "View",
          //   type: MenuTypes.ITEM,
          //   href: `${PATHS.SETTINGS}/${PATHS.EMAIL_NOTIFICATIONS}`,
          // },
          // {
          //   title: "Error / Labels",
          //   role: PERMISSION_SCOPES.Settings,
          //   type: MenuTypes.COLLAPSE_LIST,
          //   eventKey: 0,
          //   items: [
          //     {
          //       title: "Error Messages",
          //       type: MenuTypes.ITEM,
          //       role: PERMISSION_SCOPES.Settings,
          //       href: `${PATHS.SETTINGS}/${PATHS.LANGUAGE_MESSAGES}`,
          //       // linkClassName: "text-black",
          //     },
          //     {
          //       title: "Static Label",
          //       type: MenuTypes.ITEM,
          //       role: PERMISSION_SCOPES.Settings,
          //       href: `${PATHS.SETTINGS}/${PATHS.LANGAUGE_STATIC_LANG}`,
          //       // linkClassName: "text-black",
          //     },
          //   ],
          // },
        ],
      },
      {
        title: "Archived",
        type: MenuTypes.ITEM,
        role: PERMISSION_SCOPES.Archived,
        href: PATHS.ARCHIVED,
        icon: "inic inic-archive",
      },
      // {
      //   title: "Common Pages",
      //   type: MenuTypes.COLLAPSE,
      //   role: "Common Pages",
      //   icon: "bx bxs-customize",
      //   eventKey: 5,
      //   items: [
      //     {
      //       title: "404",
      //       type: MenuTypes.ITEM,
      //       href: PATHS.FourZeroFour,
      //       linkClassName: "text-black",
      //     },
      //     {
      //       title: "Thank You",
      //       type: MenuTypes.ITEM,
      //       href: PATHS.THANKYOU,
      //       linkClassName: "text-black",
      //     },
      //     {
      //       title: "Coming Soon",
      //       type: MenuTypes.ITEM,
      //       href: PATHS.COMING_SOON,
      //       linkClassName: "text-black",
      //     },
      //   ],
      // },
    ],
  },
];

export const MenuListCollapsed = [
  {
    title: "Dashboard",
    role: PERMISSION_SCOPES.Dashboard,
    icon: "inic inic-home",
    href: PATHS.DASHBOARD,
  },
  {
    title: "Users",
    role: PERMISSION_SCOPES.Users,
    icon: "inic inic-person",
    href: PATHS.USER,
  },
  {
    title: "Content",
    role: PERMISSION_SCOPES.Content,
    icon: "inic inic-file",
    href: PATHS.CONTENT,
  },
  {
    title: "Property",
    role: PERMISSION_SCOPES.Property,
    icon: "inic inic-file",
    href: PATHS.PROPERTY,
  },
  {
    title: "Investments",
    role: PERMISSION_SCOPES.Investments,
    icon: "inic inic-file",
    href: PATHS.INVESTMENT,
  },
  {
    title: "Role",
    role: PERMISSION_SCOPES.Role,
    icon: "inic inic-circle-tick",
    href: PATHS.ROLE,
  },
  {
    title: "Email Templates",
    role: PERMISSION_SCOPES.Email_Template,
    icon: "inic inic-email",
    href: PATHS.EMAIL_TEMPLATES,
  },
  {
    title: "Master",
    role: PERMISSION_SCOPES.Master,
    icon: "inic inic-crown",
    href: PATHS.MASTER_MANAGEMENT,
  },
  {
    title: "Reports",
    role: PERMISSION_SCOPES.Reports,
    icon: "inic inic-file",
    href: PATHS.REPORTS,
  },
  {
    title: "Support",
    role: PERMISSION_SCOPES.Support,
    icon: "inic inic-support",
    href: PATHS.SUPPORT,
  },
  {
    title: "Settings",
    role: PERMISSION_SCOPES.Settings,
    icon: "inic inic-settings",
    href: PATHS.SETTINGS,
  },
];
